module.exports = __webpack_public_path__ + "img/backSideLoginLogo.6432a211.png";